import { render, staticRenderFns } from "./PromotionScore.vue?vue&type=template&id=f3e0bc9c&scoped=true"
import script from "./PromotionScore.vue?vue&type=script&lang=js"
export * from "./PromotionScore.vue?vue&type=script&lang=js"
import style0 from "./PromotionScore.vue?vue&type=style&index=0&id=f3e0bc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e0bc9c",
  null
  
)

export default component.exports